import {
    GET_BANKER_RECOMMENDED_RESULTS_SUCCESS,
    RESET_QUESTIONNAIRE,
    SET_PRODUCT_FILTER_LIST,
    SET_BANKER_RECOMMENDEDN_RESULTS_FILTER,
    GET_ALL_BANKER_PRODUCTS_SUCCESS,
} from '../../constants';

const initialResultsState = {
    recommendedResultsLoaded: false,
    recommendedResults: [],
    filterList: [],
    filteredResults: [],
    allProducts: [],
};

export default function recommendationReducer(
    state = initialResultsState,
    action,
) {
    switch (action.type) {
        case RESET_QUESTIONNAIRE:
            return initialResultsState;
        case GET_BANKER_RECOMMENDED_RESULTS_SUCCESS: {
            return {
                ...state,
                recommendedResultsLoaded: true,
                recommendedResults: action.recommendedResults,
                filteredResults: action.recommendedResults,
            };
        }
        case GET_ALL_BANKER_PRODUCTS_SUCCESS: {
            return {
                ...state,
                allProductsLoaded: true,
                allProducts: action.allProducts,
                filteredResults: action.allProducts,
            };
        }
        case SET_PRODUCT_FILTER_LIST: {
            return {
                ...state,
                filterList: action.filterList,
            };
        }
        case SET_BANKER_RECOMMENDEDN_RESULTS_FILTER: {
            return {
                ...state,
                filteredResults: action.filteredResults,
            };
        }
        default:
            return state;
    }
}
